import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Header from "@/components/main/Header";
import Contents from "@/components/main/Contents";
import Footer from "@/components/main/Footer";

const Wrap = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 1000px) {
    flex-wrap: wrap;
  }
`;
const FirstWrap = styled(Wrap)`
  width: 93%;
  margin: auto;
  border-radius: 10px;
  background-color: white;
`;
const Area = styled.div`
  width: 50%;
  height: auto;
  padding: 30px 40px;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;
const FirstArea = styled(Area)`
  height: 321px;
`;
const ContentWrap = styled.div`
  position: sticky;
  top: 150px;
  right: 0;
  width: 100%;
  height: 80vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
const StickyContentWrap = styled(ContentWrap)`
  height: 70vh;
`;
const Content = styled.div<{ $bg: string }>`
  position: relative;
  margin-bottom: 30px;
  width: 100%;
  height: 50%;
  background: url(${({ $bg }) => $bg});
  background-repeat: no-repeat;
  border-radius: 10px;
  background-position: center;
  background-color: white;
  @media (max-width: 1400px) {
    height: 100%;
    background-size: contain;
  }
`;
const StickyContent = styled(Content)`
  height: 100%;
  background-size: contain;
`;

const FirstContent = styled(Content)`
  height: 100%;
  border: 1px solid black;
`;

const Title = styled.p`
  padding: 20px 0;
  color: #971b2f;
  font-weight: 700;
  font-size: 2.8rem;
  @media (max-width: 1300px) {
    font-size: 2.5rem;
  }
`;
const FirstTitle = styled(Title)`
  font-size: 3.5rem;
  @media (max-width: 1300px) {
    font-size: 2.8rem;
  }
`;
const SubTitle = styled.p`
  font-size: 1.7rem;
  margin-bottom: 10px;
  font-weight: 700;
  color: #444444;
`;
const ListTitle = styled(SubTitle)`
  margin-top: 30px;
  margin-bottom: 10px;
  color: #971b2f;
`;
const Section = styled(SubTitle)`
  color: black;
  font-weight: 700;
  font-size: 2rem;
`;
const Desc = styled.p`
  color: #676767;
  line-height: 150%;
  white-space: pre-wrap;
`;
const ImgDesc = styled(Desc)`
  position: absolute;
  left: 20px;
  bottom: 10px;
`;
const TextWrap = styled.div`
  position: sticky;
  top: 150px;
  left: 0;
`;
const ULi = styled.li`
  margin-left: 20px;
  margin-bottom: 5px;
  color: #676767;
  list-style-type: disc;
  list-style-position: outside;
`;

export default function DataIntegration() {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <FirstWrap>
        <FirstArea>
          <Section>{t("menu.support")}</Section>
          <FirstTitle>{t("menu.support.data-integration")}</FirstTitle>
          <ul>
            <ULi>
              <Desc>{t("menu.support.data-integration.support.desc-1")}</Desc>
            </ULi>
            <ULi>
              <Desc>{t("menu.support.data-integration.support.desc-2")}</Desc>
            </ULi>
          </ul>
        </FirstArea>
        <FirstArea>
          <FirstContent $bg="/support/Support-Data_Integration.webp"></FirstContent>
        </FirstArea>
      </FirstWrap>
      <Wrap>
        <Area>
          <TextWrap>
            <Section data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="100" data-aos-duration="500">
              00
            </Section>
            <Title>{t("menu.support.data-integration.00-title")}</Title>
            <ul>
              <ULi>
                <Desc>{t("menu.support.data-integration.00-desc-1")}</Desc>
              </ULi>
              <ULi>
                <Desc>{t("menu.support.data-integration.00-desc-2")}</Desc>
              </ULi>
            </ul>
          </TextWrap>
        </Area>
        <Area>
          <ContentWrap>
            <Content $bg="/support/Data-Management_1.webp">
              <ImgDesc>{t("menu.support.data-integration.img-desc-1")}</ImgDesc>
            </Content>
            <Content $bg="/support/Data-Management_2.webp">
              <ImgDesc>{t("menu.support.data-integration.img-desc-2")}</ImgDesc>
            </Content>
          </ContentWrap>
        </Area>
      </Wrap>
      <Wrap>
        <Area>
          <TextWrap>
            <Section data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="100" data-aos-duration="500">
              01
            </Section>
            <Title>{t("menu.support.data-integration.01-title")}</Title>
            <ul>
              <ULi>
                <Desc>{t("menu.support.data-integration.01-desc-1")}</Desc>
              </ULi>
              <ULi>
                <Desc>{t("menu.support.data-integration.01-desc-2")}</Desc>
              </ULi>
              <ULi>
                <Desc>{t("menu.support.data-integration.01-desc-3")}</Desc>
              </ULi>
            </ul>
            <div>
              <ListTitle>{t("menu.support.data-integration.01-sub-title")}</ListTitle>
              <ul>
                <ULi>
                  <Desc>{t("menu.support.data-integration.01-sub-desc-1")}</Desc>
                </ULi>
                <ULi>
                  <Desc>{t("menu.support.data-integration.01-sub-desc-2")}</Desc>
                </ULi>
              </ul>
            </div>
          </TextWrap>
        </Area>
        <Area>
          <ContentWrap>
            <Content $bg="/support/Data-Management_1.webp">
              <ImgDesc>{t("menu.support.data-integration.img-desc-1")}</ImgDesc>
            </Content>
            <Content $bg="/support/Data-Management_2.webp">
              <ImgDesc>{t("menu.support.data-integration.img-desc-2")}</ImgDesc>
            </Content>
          </ContentWrap>
        </Area>
      </Wrap>
      <Wrap>
        <Area>
          <TextWrap>
            <Section data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="100" data-aos-duration="500">
              02-1
            </Section>
            <Title>{t("menu.support.data-integration.02-1-title")}</Title>
            <SubTitle>{t("menu.support.data-integration.02-1-sub-title-1")}</SubTitle>
            <ul>
              <ULi>
                <Desc>{t("menu.support.data-integration.02-1-sub-desc-1-1")}</Desc>
              </ULi>
              <ULi>
                <Desc>{t("menu.support.data-integration.02-1-sub-desc-1-2")}</Desc>
              </ULi>
            </ul>
            <div>
              <ListTitle>{t("menu.support.data-integration.02-1-sub-title-2")}</ListTitle>

              <ul>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-1-sub-desc-2-1")}</Desc>
                </ULi>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-1-sub-desc-2-2")}</Desc>
                </ULi>
              </ul>

              <ListTitle>{t("menu.support.data-integration.02-1-sub-title-3")}</ListTitle>
              <ul>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-1-sub-desc-3-1")}</Desc>
                </ULi>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-1-sub-desc-3-2")}</Desc>
                </ULi>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-1-sub-desc-3-3")}</Desc>
                </ULi>
              </ul>

              <ListTitle>{t("menu.support.data-integration.02-1-sub-title-4")}</ListTitle>
              <ul>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-1-sub-desc-4-1")}</Desc>
                </ULi>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-1-sub-desc-4-2")}</Desc>
                </ULi>
              </ul>

              <ListTitle>{t("menu.support.data-integration.02-1-sub-title-5")}</ListTitle>
              <ul>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-1-sub-desc-5-1")}</Desc>
                </ULi>
              </ul>
            </div>
          </TextWrap>
        </Area>
        <Area>
          <StickyContentWrap>
            <StickyContent $bg="/support/DI_DLP.webp"></StickyContent>
          </StickyContentWrap>
        </Area>
      </Wrap>

      <Wrap>
        <Area>
          <TextWrap>
            <Section data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="100" data-aos-duration="500">
              02-2
            </Section>
            <Title>{t("menu.support.data-integration.02-2-title")}</Title>
            <SubTitle>{t("menu.support.data-integration.02-2-sub-title-1")}</SubTitle>
            <ul>
              <ULi>
                <Desc>{t("menu.support.data-integration.02-2-sub-desc-1-1")}</Desc>
              </ULi>
              <ULi>
                <Desc>{t("menu.support.data-integration.02-2-sub-desc-1-2")}</Desc>
              </ULi>
            </ul>
            <div>
              <ListTitle>{t("menu.support.data-integration.02-2-sub-title-2")}</ListTitle>
              <ul>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-2-sub-desc-2-1")}</Desc>
                </ULi>
              </ul>

              <ListTitle>{t("menu.support.data-integration.02-2-sub-title-3")}</ListTitle>
              <ul>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-2-sub-desc-3-1")}</Desc>
                </ULi>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-2-sub-desc-3-2")}</Desc>
                </ULi>
              </ul>

              <ListTitle>{t("menu.support.data-integration.02-2-sub-title-4")}</ListTitle>
              <ul>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-2-sub-desc-4-1")}</Desc>
                </ULi>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-2-sub-desc-4-2")}</Desc>
                </ULi>
              </ul>

              <ListTitle>{t("menu.support.data-integration.02-2-sub-title-5")}</ListTitle>
              <ul>
                <ULi>
                  <Desc>{t("menu.support.data-integration.02-2-sub-desc-5-1")}</Desc>
                </ULi>
              </ul>
            </div>
          </TextWrap>
        </Area>
        <Area>
          <StickyContentWrap>
            <StickyContent $bg="/support/DI_DLP2.webp"></StickyContent>
          </StickyContentWrap>
        </Area>
      </Wrap>

      <Contents
        title={t("menu.support.data-integration-enquiry")}
        desc={t("menu.support.data-integration-enquiry.desc")}
        link={"/contact/contact-us/"}
      />
      <Footer />
    </>
  );
}
